export enum GenericSize {
  LARGE = 'large',
  DEFAULT = 'default',
  SMALL = 'small',
  EXTRA_SMALL = 'extra-small',
}

export enum GenericAlign {
  LEFT = 'left',
  RIGHT = 'right',
}

export enum GenericLayout {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
  VERTICAL_CONDENSED = 'vertical-condensed',
}

export const MAX_WIDGET_WIDTH = 1280;

export const INLINE_ODDS_BREAKPOINT = 900;

export const FILTERS_BREAKPOINT = 968;

export const TABULAR_WIDGET_BREAKPOINT_1 = 768;

export const TABULAR_WIDGET_BREAKPOINT_2 = 393;

export const MAX_MOBILE_WIDTH = 429; // Most mobile devices are up to 428px wide

export const STANDINGS_DATA_ELEMENTS_BREAKPOINT = MAX_MOBILE_WIDTH;

export const KNOCKOUT_GAME_MIN_WIDTH = 250;
